import { defaultStoreUtils } from '@databases/redux';
import { selectDatabaseDraftByContentId } from '@databases/redux/changesets/selectors';
import { getDatabaseFieldRequired } from '@databases/utils/database/utils';
import React, { type FunctionComponent } from 'react';

import FieldSettingsOptionsByType from './FieldSettingsOptionsByType';

type FieldSettingsMenuContentProps = {
  contentId: string;
  fieldId: string;
};

const FieldSettingsMenuContent: FunctionComponent<FieldSettingsMenuContentProps> = ({
  contentId,
  fieldId
}) => {
  const fieldType = defaultStoreUtils.useSelector((state) => {
    const databaseDraft = selectDatabaseDraftByContentId(state, {
      contentId,
      includeDeleted: true
    });

    return getDatabaseFieldRequired(databaseDraft, fieldId).type;
  });

  // TODO: Include allowMultiToggle and default value wrapper here
  return <FieldSettingsOptionsByType fieldType={fieldType} />;
};

export default FieldSettingsMenuContent;
